import { render, staticRenderFns } from "./CompanyBrandingCard.vue?vue&type=template&id=7899507c&scoped=true&"
import script from "./CompanyBrandingCard.vue?vue&type=script&lang=js&"
export * from "./CompanyBrandingCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBrandingCard.vue?vue&type=style&index=0&id=7899507c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7899507c",
  null
  
)

export default component.exports